import { ArrowUpRight } from "lucide-react";
import { MaskedLines, Overline, Reveal, Section } from "./ui";

const situations = [
  { sit: "Minha agenda está fraca.", mod: "Agenda Viva" },
  { sit: "Tenho tempo livre.", mod: "Tempo Livre" },
  { sit: "Preciso fazer caixa.", mod: "Caixa Hoje" },
  { sit: "Quero trazer clientes.", mod: "Cliente Traz Cliente" },
  { sit: "Estou sem recepcionista.", mod: "Basic Recepção" },
  { sit: "Estou treinando uma recepcionista.", mod: "Recepção 7 Dias" },
];

export default function Modules() {
  return (
    <Section id="modulos" tone="paper">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Overline>Seis situações reais</Overline>
          <MaskedLines
            inView
            as="h2"
            className="mt-5 font-serif text-3xl font-medium leading-[1.1] tracking-tight text-hc-ink sm:text-4xl lg:text-5xl"
            lines={["O que está", "acontecendo", <em key="a" className="italic text-mom-carmim">agora?</em>]}
          />
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-xs font-dmsans text-sm leading-relaxed text-hc-mutedInk sm:text-base">
              Você conta a situação. O MOM responde com uma missão que cabe
              naquele momento do salão.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <ul className="divide-y divide-black/10 border-y border-black/10">
            {situations.map((s, i) => (
              <Reveal key={s.mod} delay={i * 0.05} y={18}>
                <li
                  data-testid={`situacao-${i}`}
                  className="group flex cursor-default items-center justify-between gap-6 py-6 transition-colors duration-300"
                >
                  <div className="flex items-baseline gap-5">
                    <span className="font-dmsans text-xs font-semibold text-black/30">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <p className="font-serif text-2xl font-medium tracking-tight text-hc-ink transition-colors duration-300 group-hover:text-mom-vinho sm:text-3xl">
                      {s.sit}
                    </p>
                  </div>
                  <div className="flex shrink-0 items-center gap-3">
                    <span className="hidden font-dmsans text-[11px] font-semibold uppercase tracking-[0.18em] text-black/40 transition-colors duration-300 group-hover:text-mom-carmim sm:block">
                      {s.mod}
                    </span>
                    <ArrowUpRight className="h-5 w-5 text-black/25 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-mom-carmim" />
                  </div>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}
